import { useState, useMemo } from 'react';

const useSearchFilter = () => {
    const [ filteredData, setFilteredData ] = useState( ); 

    const filter = ( filterValues, data ) => {
        let value = filterValues;

        // If the value is blank don't filter anything, show all items
        value = value.trim();
        if ( value === '' ) {            
            setFilteredData( undefined );
            return;
        } 

        const result = [];

        // Split the values into an array, make it lowercase, trim it, and remove blank strings
        const searchTerms = value.split( ' ' ).map( i => i.trim().toLowerCase() ).filter( f => !( f === '' ) );
        
        data.forEach( item => {
            const names = `${ item.name }`.split( ' ' ).map( i => i.toLowerCase().trim() );
            let match = false;
            searchTerms.forEach( value => {
                names.forEach ( n => { 
                    if ( n.includes( value ) ) {
                        match = true;
                    }
                } );
            } );

            // If a match add it to the result array
            if ( match ) {
                // If the name matches exactly add it to the beginning of the array
                if ( item.name === value ) {
                    result.unshift( item );
                } else {
                    result.push( item );
                }
            }
        } ); 

        // Set result to filtered items
        setFilteredData( result ); 
    };

    return useMemo( () => {
        return {
            filter,
            filteredData
        };
    }, [ filteredData ] );
};

export default useSearchFilter;
